import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { TreasuryService } from '../../core/treasury.service';
import { NotificationService } from '../../core/notification.service';

/**
 * Step 1 screen: fetch the latest US Treasury rates before running any report.
 *
 * Actuary & Finance reports price off the latest Treasury yield curve, so this
 * page walks the user through loading it. Success is remembered for the day
 * (see {@link TreasuryService}) and also raises a success notification.
 */
@Component({
  selector: 'app-treasury',
  standalone: false,
  templateUrl: './treasury.component.html',
  styleUrl: './treasury.component.scss'
})
export class TreasuryComponent {
  loading = false;
  error: string | null = null;

  constructor(
    readonly treasury: TreasuryService,
    private readonly notifications: NotificationService,
    private readonly router: Router
  ) {}

  /** Fetches and stores the latest Treasury rates, marking the step complete on success. */
  fetchRates(): void {
    this.loading = true;
    this.error = null;
    this.treasury.loadLatest().subscribe({
      next: () => {
        this.loading = false;
        this.treasury.markLoadedToday();
        this.notifications.success('Success', 'Latest Treasury rates loaded.');
      },
      error: () => {
        this.loading = false;
        this.error = 'Could not load Treasury rates. Please try again.';
      }
    });
  }

  /** Continues to the division landing so the user can pick a report set. */
  continue(): void {
    void this.router.navigateByUrl('/');
  }
}
